import styled from 'styled-components';
import MessageList from './component';

export default styled(MessageList)`
  flex: 1;
  padding: 20px 15px 20px 10px;
  display: flex;
  flex-direction: column;
  background-color: var(--grey900);
  overflow: scroll;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #e2e8ee;
  }

  .loading,
  .not-started {
    height: 100%;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .closed {
    color: var(--grey700);
    background-color: var(--grey100);
    font-weight: bolder;
    margin: 16px auto;
    padding: 6px;
    border-radius: 2px;
  }

  .loading {
    margin: auto;
  }

  .not-started {
    flex-direction: column;
    text-align: center;

    p {
      max-width: 156px;
    }

    .create-conversation {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;
